<template>
  <div>
    <v-navigation-drawer
      app
      id="core-navigation-drawer"
      v-model="drawer"
      :right="false"
      dark
      mobile-breakpoint="640"
      width="230"
    >
      <template v-slot:img="props">
        <v-img :gradient="`to bottom`" v-bind="props" />
      </template>

      <v-divider class="mb-1" />

      <v-list dense nav>
        <v-list-item>
          <v-list-item-avatar class="align-self-center" color="white" contain>
            <v-img src="../../../files/img/user.png" max-height="42" />
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title
              class="py-2"
              v-text="user.name"
            ></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-divider class="mb-2"></v-divider>

      <v-list expand nav dense>
        <v-subheader>Menú</v-subheader>
        <v-list-item link to="/admin_ordenes">
          <v-list-item-icon>
            <v-icon>mdi-format-list-bulleted</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title no-action>Lista de ordenes</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to="/carga_masiva">
          <v-list-item-icon>
            <v-icon>mdi-cloud-upload</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title no-action>Carga masiva</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to="/campana">
          <v-list-item-icon>
            <v-icon>mdi-hospital-building</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title no-action>Campañas</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <!--  <v-list-group
                        prepend-icon="mdi-vector-circle"
                        no-action
                        v-if="menuConfig.length>0"
                        link
                >
                    <template v-slot:activator>
                        <v-list-item-content>
                            <v-list-item-title>Configuraciones</v-list-item-title>
                        </v-list-item-content>
                    </template>

                    <v-list-item
                            :dense=true
                            sub-group
                            v-for="(item, x) in menuConfig"
                            :key=x
                            :to=item.url
                            class="pl-5"
                    >
                        <v-icon v-text="item.icon"></v-icon>
                        <v-list-item-title
                                class="pl-3 text-decoration-none"
                                v-text="item.name"
                        ></v-list-item-title>
                    </v-list-item>
                </v-list-group> -->
      </v-list>
    </v-navigation-drawer>
    <v-app-bar
      id="app-bar"
      absolute
      app
      color="transparent"
      flat
      height="50"
      v-if="loggedIn"
    >
      <v-btn
        class="mr-3 white--text"
        elevation="1"
        fab
        small
        @click="drawer = !drawer"
        :depressed="true"
        color="white"
      >
        <v-icon color="grey darken-1" v-if="drawer"> mdi-close </v-icon>
        <v-icon color="grey darken-1" v-else> mdi-dots-vertical </v-icon>
      </v-btn>

      <v-toolbar-title class="hidden-sm-and-down font-weight-light" />

      <v-spacer />

      <div class="mx-3" title="Falta por cotización">
        <v-menu
          bottom
          left
          offset-y
          origin="top right"
          transition="scale-transition"
          v-if=viewNotificactions
        >
          <template v-slot:activator="{ on }" :v-if="listNotificationsActionWithoutQuote">
            <v-btn
              class="ml-2 white--text"
              min-width="0"
              fab
              small
              v-on="on"
              color="grey darken-1"
            >
              <v-badge color="red" overlap bordered>
                <template v-slot:badge>
                  <span>{{cantNotificationsWithoutQuote}}</span>
                </template>

                <v-icon>mdi-cash-usd</v-icon>
              </v-badge>
            </v-btn>
          </template>
          <v-list :tile="false" nav class="py-0">
            <div>
              <v-list v-for="(n, i) in notificationsWithoutQuote" :key="i">
                <!-- <v-list-item-title class="p-1" @click="LoadCompany(n)"> -->
                <v-list-item-title class="p-1">
                  <v-icon color="primary">mdi mdi-alert-outline</v-icon> 
                    Cotización de {{n.cantidad}} orden{{n.cantidad> 1 ? 'es' :''}} pendiente de  {{typeof n.group_name == 'undefined' ? 'particulares' : 'la empresa '+n.group_name}}
                </v-list-item-title>
              </v-list>
            </div>
          </v-list>
        </v-menu>
      </div>
      <div class="mx-3" title="Falta por carga de archivo">
        <v-menu
          bottom
          left
          offset-y
          origin="top right"
          transition="scale-transition"
          v-if=viewNotificactions
        >
          <template v-slot:activator="{ on }" :v-if="listNotificationsAction">
            <v-btn
              class="ml-2 white--text"
              min-width="0"
              fab
              small
              v-on="on"
              color="grey darken-1"
            >
              <v-badge color="red" overlap bordered>
                <template v-slot:badge>
                  <span>{{ cantNotifications }}</span>
                </template>

                <v-icon>mdi-file-import</v-icon>
              </v-badge>
            </v-btn>
          </template>
          <v-list :tile="false" nav class="py-0">
            <div>
              <v-list v-for="(n, i) in notifications" :key="i">
                <v-list-item-title class="p-1" @click="LoadOrder(n)">
                  <v-icon color="primary">mdi mdi-alert-outline</v-icon> Orden
                  pendiente N# {{ n.olab_id }} de fecha {{ n.olab_fecha }}
                </v-list-item-title>
              </v-list>
            </div>
          </v-list>
        </v-menu>
      </div>
      <v-btn
        class="ml-2 white--text"
        min-width="0"
        link
        color="grey darken-1"
        @click="logout"
      >
        <v-icon>mdi-logout-variant</v-icon> Salir
      </v-btn>
    </v-app-bar>
    <v-overlay :value="overlay">
      <v-progress-circular
        indeterminate
        :absolute="true"
        size="64"
      ></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import { mapMutations, mapActions, mapState } from "vuex";

export default {
  name: "NavPrivateComponent",
  props:{
    viewNotificactions:{
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    drawer: true,
    barColor: "rgba(0, 0, 0, .8), rgba(0, 0, 0, .8)",
    barImage:
      "https://demos.creative-tim.com/material-dashboard/assets/img/sidebar-1.jpg",
    overlay: false,
  }),
  computed: {
    loggedIn() {
      return this.$store.getters.getIsLoggedIn;
    },
    ...mapState([
      "user",
      "token",
      "listNotificationsAction",
      "notifications",
      "cantNotifications",,
      "listNotificationsActionWithoutQuote",
      "notificationsWithoutQuote",
      "cantNotificationsWithoutQuote"
    ]),
  },
  methods: {
    ...mapMutations(["setUrl", "setLogedIn", "setActionsRol"]),

    ...mapActions(["requestApi", "errorRequest"]),

    logout() {
      console.log(this.user.user_ligin_id);
      this.setUrl("user-laboratorio");
      this.overlay = true;
      this.requestApi({
        method: "DELETE",
        data: {
          access_token: this.token,
          userLoginId: this.user.user_ligin_id,
          dataBase: "obinnoclinica",
          system: "laboratorio",
          comment:
            "ha cerrado sesión en el sistema de consultas de examenes médicos del laboratorio",
        },
      })
        .then((res) => {
          localStorage.removeItem("token");
          localStorage.setItem("user", "");
          this.setLogedIn(false);
          this.setActionsRol();
          if (!this.loggedIn) this.$router.push("/login");

          this.overlay = false;
        })
        .catch((err) => {
          let response = err.response;
          this.errorRequest({
            data: {
              datos: response.data.errors,
              status: response.status,
            },
          });
          this.overlay = false;
        });
    },

    LoadOrder(data) {
      this.$emit("LoadOrder", data);
    },

    LoadCompany(data) {
      this.$emit("LoadCompany", data);
    },
  },
  created() {
    console.log(this.listNotificationsAction);
  },
};
</script>

<style>
</style>